module.exports = __webpack_public_path__ + "img/가락시장 미용실.ffcfb617.png";